import { render } from "./ProductCategoryProductsComponent.vue?vue&type=template&id=5a77d75b"
import script from "./ProductCategoryProductsComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/ProductCategoryProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a77d75b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a77d75b', __exports__)) {
    api.reload('5a77d75b', __exports__)
  }
  
  module.hot.accept("./ProductCategoryProductsComponent.vue?vue&type=template&id=5a77d75b", () => {
    api.rerender('5a77d75b', render)
  })

}


export default __exports__